import Users from '../components/users/Users';
import UsersCreate from '../components/users/UsersCreate';
import UsersEdit from '../components/users/UsersEdit';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/users',
  component: Template,
  children: [
    {
      path: '',
      name: 'Users',
      component: Users,
      meta: {
        title: 'Users - Mod24',
      },
    },
    {
      path: 'create',
      name: 'UsersCreate',
      component: UsersCreate,
      meta: {
        title: 'Create User - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'UsersEdit',
      component: UsersEdit,
      meta: {
        title: 'Edit User - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/usersRoutes.js